import {CTA} from '@volkswagen-onehub/components-core';
import {Close} from '@volkswagen-onehub/icons-core';
import * as React from 'react';

export interface CloseButtonProps {
  readonly ariaLabel?: string;
  readonly onClick?: () => void;
}

export function CloseButton({
  ariaLabel,
  onClick,
}: CloseButtonProps): JSX.Element {
  return (
    <CTA
      tag="button"
      emphasis="tertiary"
      aria-label={ariaLabel}
      onClick={(e) => {
        if (!onClick) {
          return;
        }

        e.stopPropagation();

        return onClick();
      }}
      icon={<Close />}
    />
  );
}
